import styled from "styled-components";
import FONTS from "../../constants/fonts";

export const WholeWrapper = styled.div`
  width: 100%;
  min-height: 10.4rem;
  background: #08183F;
  height: 10.4rem;
  padding: 2rem 4rem;
  display: flex;
  align-items: center;
  font-family: ${FONTS.UbuntuLight};
  font-size: 3.2rem;
  line-height: 3.6rem;
  letter-spacing: 1px;
  color: white;
  border-bottom: 0.4rem solid #ffffff33;
`;

export const HeaderIcon = styled.div`
  width: 4.8rem;
  height: 4.8rem;
  background: linear-gradient(121.45deg, #030a1b -41.87%, #026c8e 141.08%);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 2.4rem;
`;
